'use client';

import dynamic from 'next/dynamic';

// Client-side dynamic imports with ssr: false
export const StoreVideo = dynamic(
  () => import('@/components/store/StoreVideo'),
  {
    loading: () => (
      <div className="h-64 w-full animate-pulse rounded bg-gray-200" />
    ),
    ssr: false,
  }
);

export const PostReview = dynamic(
  () => import('@/components/store/PostReview'),
  {
    ssr: false,
  }
);

export const RatingAndReview = dynamic(
  () => import('@/components/store/RatingAndReview'),
  {
    ssr: false,
  }
);

export const Events = dynamic(() => import('@/components/store/Events'), {
  ssr: false,
});

export const RestaurantFAQ = dynamic(
  () => import('@/components/store/RestaurantFAQ'),
  {
    ssr: false,
  }
);

export const RestaurantMenu = dynamic(
  () => import('@/components/store/categories/RestaurantMenu'),
  {
    ssr: false,
  }
);

export const SimilarRestaurantsCarousel = dynamic(
  () => import('@/components/store/SimilarRestaurantsCarousel'),
  {
    ssr: false,
  }
);

export const Categories = dynamic(
  () => import('@/components/store/categories/Categories'),
  { ssr: false }
);

// Account page components
export const ProfileForm = dynamic(
  () => import('@/components/account/profile/ProfileForm'),
  {
    ssr: false,
  }
);

// Vendor components
export const VendorProvenExpert = dynamic(
  () => import('@/components/vendor/home/VendorProvenExpert'),
  {
    ssr: false,
  }
);
